import { render, staticRenderFns } from "./create-patient.vue?vue&type=template&id=99870eda&scoped=true"
import script from "./create-patient.vue?vue&type=script&lang=js"
export * from "./create-patient.vue?vue&type=script&lang=js"
import style0 from "./create-patient.vue?vue&type=style&index=0&id=99870eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99870eda",
  null
  
)

export default component.exports